<template>
<svg viewBox="0 0 10 8.75">
    <path fill="currentColor" d="M10,7.812C10,8.33,9.58,8.75,9.062,8.75H0.938C0.42,8.75,0,8.33,0,7.812V2.188C0,1.67,0.42,1.25,0.938,1.25
        h1.719l0.24-0.643C3.033,0.242,3.383,0,3.773,0h2.451c0.391,0,0.74,0.242,0.877,0.607L7.344,1.25h1.719C9.58,1.25,10,1.67,10,2.188
        V7.812z M5,2.656C3.707,2.656,2.656,3.707,2.656,5S3.707,7.344,5,7.344S7.344,6.293,7.344,5S6.293,2.656,5,2.656z M5,6.719
        C4.053,6.719,3.281,5.947,3.281,5S4.053,3.281,5,3.281S6.719,4.053,6.719,5S5.947,6.719,5,6.719z"/>
</svg>
</template>
